<template>
  <div class="page">
    <c-source-page
      :columns="columns"
      :filter="filter"
      :table="table"
      :pagination="pagination"
      createButtonText="新建管理员"
      resource="admin_users"
    />
  </div>
</template>


<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class AdminUsers extends Vue {

  table = { data: [] }
  pagination = {}

  filter = [
    {
      prop: 'email_cont',
      label: '邮箱',
      form: {
        component: 'input',
        props: {
          placeholder: '请输入关键字'
        }
      }
    }
  ]

  get columns() {
    return [
      ...createColumns.call(this),
      {
        prop: 'action',
        label: '操作',
        fixed: 'right',
        width: 140,
        detail: true,
        edit: true
      }
    ]
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/admin_users', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }

  async handleDelete({ row }) {
    await this.$request.delete(`/admin_users/${row.id}`);
    this.fetchData();
  }
}
</script>
